import http from '@/services/http'

export default {
  namespaced: true,
  state: {
    schema: null,
    manufactures: [],
    loading: false,
    savingSettings: false,
    error: null,
    selectedManufactoryIds: []
  },
  getters: {
    isLoading: state => state.loading,
    isSavingSettings: state => state.savingSettings,
    getSchema: state => state.schema?.columns ?? [],
    getManufactures: state => state.manufactures,
    getSelectedManufactoryIds: state => state.selectedManufactoryIds,
    getSelectedManufactories: state => {
      return state.manufactures.filter(
        m => state.selectedManufactoryIds.includes(m.manufacture_id)
      )
    }
  },
  mutations: {
    SET_RESPONSE(state, { settings_schema, manufactures }) {
      state.schema = settings_schema
      state.manufactures = manufactures
    },
    SET_LOADING(state, isLoading) {
      state.loading = isLoading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_SELECTED_MANUFACTORY_IDS(state, ids) {
      state.selectedManufactoryIds = ids
    },
    TOGGLE_MANUFACTORY_SELECTION(state, manufactureId) {
      const index = state.selectedManufactoryIds.indexOf(manufactureId)
      if (index === -1) {
        state.selectedManufactoryIds.push(manufactureId)
      } else {
        state.selectedManufactoryIds.splice(index, 1)
      }
    },
    SELECT_ALL_MANUFACTORIES(state) {
      state.selectedManufactoryIds = state.manufactures.map(m => m.manufacture_id)
    },
    CLEAR_SELECTION(state) {
      state.selectedManufactoryIds = []
    },
    SET_SAVING_SETTINGS(state, isSaving) {
      state.savingSettings = isSaving
    },
    UPDATE_SETTINGS_VALUES(state, manufactures) {
      manufactures.forEach(update => {
        const manufacture = state.manufactures.find(m => m.manufacture_id === update.manufacture_id)
        if (manufacture && update.settings) {
          Object.assign(manufacture.settings, update.settings)
        }
      })
    }
  },
  actions: {
    async fetchSettings({ commit, rootState }, payload = {}) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const params = {}
        const { selectedCity, selectedAreas } = rootState.manufactures
        if (selectedCity) {
          params.city_id = selectedCity.id
        }
        if (selectedAreas && selectedAreas.length) {
          params.areas_ids = selectedAreas.map(a => a.area_id).join(',')
        }
        if (payload.manufacture_ids) {
          params.manufacture_ids = payload.manufacture_ids
        }
        const response = await http.get('/manufactories/settings', { v3: true, params })
        commit('SET_RESPONSE', response)
        return response
      } catch (error) {
        commit('SET_ERROR', error)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    toggleManufactorySelection({ commit }, manufactureId) {
      commit('TOGGLE_MANUFACTORY_SELECTION', manufactureId)
    },
    selectAllManufactories({ commit }) {
      commit('SELECT_ALL_MANUFACTORIES')
    },
    clearSelection({ commit }) {
      commit('CLEAR_SELECTION')
    },
    setSelectedManufactoryIds({ commit }, ids) {
      commit('SET_SELECTED_MANUFACTORY_IDS', ids)
    },

    async saveSettings({ commit }, payload) {
      commit('SET_SAVING_SETTINGS', true)
      commit('SET_ERROR', null)
      try {
        await http.patch('/manufactories/settings', payload, { v3: true })
        commit('UPDATE_SETTINGS_VALUES', payload.manufactures)
      } catch (error) {
        commit('SET_ERROR', error)
        throw error
      } finally {
        commit('SET_SAVING_SETTINGS', false)
      }
    }
  }
}
